import { Grid } from 'antd';
import Title from 'antd/es/skeleton/Title';
import Colors from 'enums/Colors';
import { Description } from 'pages/biblioteca_v2/components/categoria-item/DefaultItem.styled';
import NotFound from 'pages/not_found/NotFound';
import { ButtonsContainer } from 'pages/pdp/UI/dialog/DialogFinal.styled';
import { Container } from 'react-bootstrap';
import styled from 'styled-components';

const FerramentaVideoPublicStyled = {
    Global: {
        Container: styled.div<{ img?: string }>`
            display: flex;
            flex-direction: column;
            background: ${props =>
                props.img
                    ? `
                    linear-gradient(270deg, rgba(0, 60, 120, 0.4) 0%, #003c78 90%),
                    linear-gradient(180deg, rgba(0, 60, 120, 0.4) 0%, #003c78 100%),
                    url(${props.img}), #003c78
                `
                    : `
                  linear-gradient(270deg, rgba(0, 60, 120, 0.4) 0%, #003C78 70%);

                    
                `};
            background-repeat: no-repeat, no-repeat, no-repeat, repeat;
            background-size: 100%;
            background-position: top, top, top, top;
            min-height: 100vh;
        `,

        Content: styled.div`
            display: flex;
            align-self: center;
            width: 100%;
            max-width: 1280px;
            @media screen and (max-width: 1380px) {
                padding-left: 22px;
            }
        `,

        ButtonBack: styled.button`
            display: flex;
            align-items: center;
            justify-content: center;
            gap: 0.5rem;
            height: 67px;
            min-width: 427px;
            max-width: 600px;
            opacity: 1;
            border-radius: 8px;
            border-width: 1px;
            padding: 16px 22px;
            background-color: transparent;
            font-family: 'Barlow';
            font-weight: 600;
            font-size: 32px;
            line-height: 150%;
            border: 1px solid ${Colors.White};
            color: ${Colors.White};

     
            @media screen and (max-width: 720px) {
                font-size: 24px;
                padding: 12px;

                min-height: 52px;
            }
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 40px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.White};
        `,
    },

    InitialAccess: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            height: 100%;
            background-color: #d4d6de;
            padding-top: 20px;

            @media screen and (max-width: 1280px) {
                padding-left: 22px;
                padding-right: 22px;
            }
        `,
        Content: styled.div`
            display: flex;
            align-items: center;
            height: 100%;
            flex-direction: column;
            width: 100%;
            max-width: 1280px;
            margin-bottom: 22px;
        `,

        Block: styled.div`
            display: flex;
            align-items: center;
            flex-direction: column;
            gap: 20px;
        `,

        ButtonsContainer: styled.div`
            display: flex;
            align-items: center;
            gap: 40px;
        `,

        Button: styled.button`
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            width: 130px;
            height: 130px;
            border-radius: 100%;
            background-color: #333333;
            border: none;
            transition: all 0.3s;
            color: ${Colors.White};
            text-transform: uppercase;
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 12px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;

            //Mudar o background na navegação via tab ou seja no focus também.
            &:focus {
                background-color: ${Colors.Blue};
            }

            &:hover {
                background-color: ${Colors.Blue};
                cursor: pointer;
            }
        `,

        ContainerImg: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            width: 254px;
            height: 229px;
            border-radius: 15px;
            background-color: ${Colors.White};
        `,

        ImgSolucoes: styled.img`
            width: 155px;
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 40px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
            color: ${Colors.Blue};

            @media screen and (max-width: 600px) {
                text-align: center;
            }
        `,

        Footer: {
            Container: styled.div`
                display: flex;
                flex-direction: column;
            `,

            ContentRegua: styled.div`
                width: 100%;
                background-color: ${Colors.White};
            `,

            ReguaLogo: styled.img`
                object-fit: contain;
                height: 115px;
                width: 100%;
            `,
        },
    },

    NotFound: {
        Container: styled.div`
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100%;
        `,

        Content: styled.div`
            display: flex;
            align-items: center;
            padding-top: 23px;
            flex-direction: column;
            width: 100%;
            max-width: 1280px;
            gap: 22px;
        `,

        Title: styled.h1`
            font-family: 'Roboto', sans-serif;
            font-style: normal;
            font-weight: 700;
            font-size: 36px;
            line-height: 42px;
            color: ${Colors.Yellow};
        `,
    },

    Home: {
        Container: styled.div`
            display: flex;
            flex-direction: column;
            gap: 20px;
            width: 100%;
            color: ${Colors.White};
        `,

        Title: styled.h1`
            font-family: 'Barlow';
            font-weight: 700;
            font-style: Bold;
            font-size: 40px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
            text-transform: uppercase;
        `,

        Description: styled.p`
            font-family: 'Barlow';
            font-weight: 500;
            font-style: Medium;
            font-size: 24px;
            line-height: 150%;
            letter-spacing: -1%;
            vertical-align: middle;
        `,

        GridPackages: styled.div`
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
            margin-bottom: 22px;
            width: 100%;

            @media screen and (max-width: 1280px) {
                grid-template-columns: 1fr;
            }
        `,

        Card: {
            Container: styled.div`
                display: flex;
                border-radius: 12px;
                width: fit-content;
                height: 380px;
                box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.1);
                transition: all 0.3s ease;
                cursor: pointer;
                z-index: 2;

                &:hover {
                    transform: translateY(-4px);
                    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.1);

                    .hoverCardPackage {
                        background: ${Colors.Yellow};
                    }
                }

                img {
                    height: 140px;
                    width: 100%;
                    object-fit: contain;
                }

                h1 {
                    color: ${Colors.Blue};
                    font-size: 26px;
                    font-weight: 700;
                }

                p {
                    color: ${Colors.BlueGrey};
                    font-size: 16px;
                    font-weight: 400;
                    line-height: 18px;
                    max-width: 100%;
                }

                @media screen and (max-width: 660px) {
                    flex-direction: column-reverse;

                    .contentImg {
                        width: 600px !important;
                        height: 380px !important;
                        border-radius: 10px 10px 0px 0px;
                        background-size: contain;
                        background-color: ${Colors.Blue};

                        @media screen and (max-width: 626px) {
                            width: 500px !important;
                        }
                        @media screen and (max-width: 526px) {
                            width: 400px !important;
                        }
                        @media screen and (max-width: 426px) {
                            width: 380px !important;
                        }

                        @media screen and (max-width: 376px) {
                            width: 340px !important;
                        }
                    }

                    .content {
                        border-radius: 0px 0px 10px 10px;
                        width: 100%;
                    }
                }
            `,

            Content: styled.div<{ width: string; color?: string; background?: string; img?: string; radius?: string }>`
                width: ${props => props.width};
                display: flex;
                align-items: center;
                justify-content: center;
                color: ${props => props.color || Colors.Blue};
                background: ${props => props.background || 'transparent'};
                background-image: url(${props => props.img});
                background-size: cover;
                background-position: center;
                background-repeat: no-repeat;
                border-radius: ${props => props.radius || '0px'};
                transition: all 0.3s ease;

                h1 {
                    font-size: 110px;
                }
            `,

            Information: {
                Container: styled.div`
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    max-width: 600px;

                    button {
                        align-self: end;
                        
                        @media screen and (max-width: 700px) {
                            align-self: start;
                        }
                    }
                `,

                Title: styled.h2<{ hovered?: boolean }>`
                    font-size: 32px;
                    line-height: 40px;
                    font-weight: 700;
                    text-transform: uppercase;
                    color: ${({ hovered }) => (hovered ? Colors.Yellow : Colors.White)};
                `,
                Description: styled.p`
                    font-family: 'Barlow';
                    font-weight: 500;
                    font-style: Medium;
                    font-size: 24px;
                    line-height: 150%;
                    letter-spacing: -1%;
                    vertical-align: middle;

                    color: ${Colors.White};
                `,
            },
        },
        RowBettween: styled.div`
            display: flex;
            justify-content: space-between;
            align-items: center;
        `,
    },

    Package: {
        Content: styled.div`
            display: flex;
            height: 100%;
            flex-direction: column;
            width: 100%;
            margin-bottom: 22px;
            gap: 1rem;
        `,

        Page: {
            Container: styled.div`
                display: flex;
                flex-direction: column;
                gap: 2rem;
            `,

            Column: styled.div`
                flex: flex;
                flex-direction: column;
                width: 500px;
                padding: 16px;

                @media screen and (max-width: 530px) {
                    width: 100%;
                }
            `,

            Row: styled.div`
                display: flex;
                flex-direction: row;
                gap: 16px;

                @media screen and (max-width: 900px) {
                    flex-direction: column-reverse;
                }
            `,

            SubTitle: styled.h2`
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
                font-size: 32px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                text-transform: uppercase;
                color: ${Colors.White};
            `,

            Title: styled.h1`
                font-family: 'Barlow';
                font-weight: 700;
                font-style: Bold;
            font-size: 40px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                text-transform: uppercase;
                color: ${Colors.Yellow};
            `,

            Description: styled.p`
                font-family: 'Barlow';
                font-weight: 500;
                font-style: Medium;
                font-size: 24px;
                line-height: 150%;
                letter-spacing: -1%;
                vertical-align: middle;
                color: ${Colors.White};
                margin-top: 32px;
            `,

            Card: {
                Container: styled.div`
                    display: flex;
                    width: 744px;
                    height: 380px;
                    border-radius: 24px;
                    overflow: hidden;

                    @media screen and (max-width: 800px) {
                        width: 100%;
                    }

                    @media screen and (max-width: 640px) {

                        .contentImg {
                            width: 600px !important;
                            height: 380px !important;
                            border-radius: 10px 10px 0px 0px;
                            background-size: contain;
                            background-color: ${Colors.Blue};

                            @media screen and (max-width: 626px) {
                                width: 500px !important;
                            }
                            @media screen and (max-width: 526px) {
                                width: 400px !important;
                            }
                            @media screen and (max-width: 426px) {
                                width: 380px !important;
                            }

                            @media screen and (max-width: 376px) {
                                width: 340px !important;
                            }
                        }

                        .contentInfo {
                            display: flex;

                            h2 {
                                font-size: 32px;
                            }
                        }
                    }
                `,

                Content: styled.div<{ img?: string; backcolor?: string }>`
                    width: 50%;
                    background-image: url(${props => props.img});
                    background-size: contain;
                    background-position: center;
                    background-repeat: no-repeat;
                    background-color: ${props => props.backcolor};
                    color: ${Colors.Blue};
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;

                    h2 {
                        font-family: 'Barlow';
                        font-weight: 700;
                        font-style: Bold;
                        font-size: 48px;
                        line-height: 150%;
                        letter-spacing: -1%;
                        vertical-align: middle;
                        text-transform: uppercase;
                    }

                    h1 {
                        font-family: 'Barlow';
                        font-weight: 700;
                        font-style: Bold;
                        font-size: 149.84px;
                        line-height: 150%;
                        letter-spacing: -1%;
                        text-align: center;
                        vertical-align: middle;
                    }
                `,
            },

            ContentGrid: styled.div`
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 16px;

                @media screen and (max-width: 1280px) {
                    grid-template-columns: 600px;
                }
                @media screen and (max-width: 640px) {
                    grid-template-columns: 1fr;
                }
            `,
        },
    },
};

export default FerramentaVideoPublicStyled;
